import { ScoreTextsData } from 'services/api/wordEmbedding/types';

export const getScoringFromMappersResult = (result: ScoreTextsData) => ({
  readability: result.mapper_scores.find(({ id }) => id === 'readability')?.score ?? 0,
  emotionality: result.mapper_scores.find(({ id }) => id === 'emotionality')?.score ?? 0
});
